import YotpoGlobalReviews from '@containers/GlobalReviews/YotpoGlobalReviews'
import cn from 'classnames'
import { FC } from 'react'

interface props {
  primary: {
    padding_top: string
    background_colour: string
  }
}

const Reviews: FC<props> = ({ primary }) => {
  const { padding_top, background_colour } = primary

  return (
    <>
      <section
        className={cn(`reviews-block pb-48 laptop:pb-80`, {
          'pt-48 laptop:pt-80': padding_top,
        })}
      >
        <YotpoGlobalReviews />
      </section>
    </>
  )
}

export default Reviews
